import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import {
  selectLearnerAnalytics,
  selectLearnerAnalyticsLoaded,
  selectLearnerAnalyticsLoading,
} from "../../../../redux/learner/selector";
import { getLearnerAnalytics } from "../../../../redux/learner/actions";

const mapStateToProps = (state: StateType) => ({
  analytics: selectLearnerAnalytics(state),
  analyticsLoading: selectLearnerAnalyticsLoading(state),
  analyticsLoaded: selectLearnerAnalyticsLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getLearnerAnalytics,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
